import { MessageCircle } from "lucide-react";

export const FloatingWhatsapp = () => (
    <a
        href="https://api.whatsapp.com/send?phone=5511940272123&text=Ol%C3%A1%2C%20quero%20falar%20com%20a%20Buzas"
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Falar no WhatsApp"
        className="fixed bottom-20 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-buzas-red text-white px-4 py-3 shadow-xl hover:bg-buzas-red-600 transition-colors"
    >
        <MessageCircle className="h-5 w-5" />
        <span className="text-sm font-bold hidden sm:inline">WhatsApp</span>
    </a>
);
